import { Body, Heading, Label } from '@nx/fire/typography'
import styled from 'styled-components'

export const StyledCostCalculatorContainer = styled.div``

export const StyledHeading = styled(Heading)`
  margin-bottom: 5px;
`

export const StyledSubHeading = styled(Body)`
  margin: 5px 0px 30px;
`

export const StyledLotContainer = styled.div`
  ${({ theme }) => theme.helpers.topSeparationLine}
  padding-top: 30px;
  display: flex;
  width: 100%;
`

export const StyledLotInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 45px;
`

export const StyledLotName = styled(Label)`
  ${({ theme }) => theme.fontStyles.sangbleu.medium}
  margin-bottom: 5px;
`

export const StyledAuctionName = styled(Body)`
  margin-bottom: 15px;
`

export const StyledLotPrice = styled.div`
  p {
    color: ${({ theme }) => theme.colours.primary.charcoal};
    font-weight: 400;
  }
`

export const StyledImageContainer = styled.div`
  position: relative;
  width: 140px;
  height: 133px;
`

export const StyledRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 52px;
  padding: 14px 15px 14px 20px;
`

export const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledItem = styled(Body)`
  margin-bottom: 0;
`

export const StyledPrice = styled(Body)`
  margin-bottom: 0;
  margin-left: 10px;
  ${({ theme }) => theme.fontStyles.sourceSans.medium};
  display: flex;
  align-items: center;

  input {
    ${({ theme }) => theme.typography.body.M}
    font-weight: 600;
    margin: 0;
    text-align: right;
    padding-right: 10px;
  }
`

export const StyledTable = styled.div`
  margin: 30px 0;
  ${StyledRow}:nth-child(odd) {
    background-color: ${({ theme }) => theme.colours.grey['15']};
  }
`

export const StyledTotalContainer = styled.div`
  ${({ theme }) => theme.helpers.topSeparationLine}
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 15px;
  margin-top: 14px;
`

export const StyledTotalText = styled(Body)`
  font-weight: 600;
  margin-bottom: 0;
`

export const StyledTotalQuantity = styled(StyledTotalText)`
  margin-left: 7px;
`

export const StyledDisclaimer = styled(Body)`
  font-style: italic;
  color: ${({ theme }) => theme.colours.grey['90']};
`
